import React, { useEffect } from 'react'

import { FloraButton, FloraTypography } from '@grupoboticario/flora-react'
import { ArrowClockwiseIcon } from '@grupoboticario/flora-react-icons'

import { ReactComponent as NoWifiConnectionIllustration } from '~/assets/images/icons/ds/no-wifi-connection.svg'
import useTracking from '~/services/tracking'

import * as Styled from './styles'

const PremiacaoSemConexao = () => {
  const tracking = useTracking()

  useEffect(() => {
    tracking({ event: 'sem_conexao_page_view' })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleRetry = () => {
    tracking({ event: 'sem_conexao_tentar_novamente_click' })
    window.location.reload()
  }

  return (
    <Styled.Page>
      <Styled.IllustrationSection>
        <Styled.Illustration as={NoWifiConnectionIllustration} aria-hidden role='presentation' />
      </Styled.IllustrationSection>

      <Styled.ContentSection>
        <Styled.ContentInner>
          <FloraTypography
            as='h1'
            fontSize='title'
            fontWeight='regular'
            viewport='mobile'
            id='sem-conexao-title'
            css={{
              margin: 0,
              color: '$nonInteractivePredominant',
              textAlign: 'center'
            }}
          >
            Sem conexão com a internet
          </FloraTypography>

          <FloraTypography
            as='p'
            fontSize='bodyLargeStandard'
            fontWeight='regular'
            viewport='mobile'
            css={{ textAlign: 'center', color: '$nonInteractiveAuxiliar' }}
          >
            Verifique o sinal do seu Wi-Fi ou dados móveis para continuar.
          </FloraTypography>
        </Styled.ContentInner>
      </Styled.ContentSection>

      <Styled.ActionsSection>
        <Styled.ActionsInner>
          <FloraButton
            hierarchy='secondary'
            size='medium'
            surfaceColor='light'
            isFull
            has='iconLeft'
            icon={<ArrowClockwiseIcon />}
            onClick={handleRetry}
            aria-label='Tentar novamente'
          >
            Tentar novamente
          </FloraButton>
        </Styled.ActionsInner>
      </Styled.ActionsSection>
    </Styled.Page>
  )
}

export default PremiacaoSemConexao
